import {$window, $body} from '../../../Constants';
import SwiperSlider from '../../../Elements/SwiperSlider';

/**
 * Locations Slider
 */
const LocationsSlider = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		LOCATIONS_SLIDER: '.locations .swiper-container',
	};

	/**
	 * Class Name
	 *
	 * @var { Object }
	 */
	const ClassName = {
		CAN_CENTER: 'can-center'
	};

	/**
	 * Locations Slider
	 *
	 * @class
	 * @augments SwiperSlider
	 */
	class LocationsSlider extends SwiperSlider {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this.setOptions({
				spaceBetween: !this.$element.hasClass('collapse') ? 30 : 0,
				slidesPerView: this.$element.data('cols-large'),
				grabCursor: true,
				pagination: {
					el: this.constructor.Selector.PAGINATION,
					clickable: true
				},
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
				},
				breakpoints: {
					1600: {
						slidesPerView: this.$element.data('cols-large')
					},
					1200: {
						slidesPerView: this.$element.data('cols-large') > 4 ? this.$element.data('cols-large') - 2 : this.$element.data('cols-large') - 1
					},
					1023: {
						slidesPerView: this.$element.data('cols-medium')
					},
					639: {
						slidesPerView: 1
					}
				}
			});

			this._initialize();
			this._bindHandlers();

			if (Boolean(this.$element.data('center'))) {
				this._handleCentering();
			}
		}

		/**
		 * Binds the event handlers to the elements
		 *
		 * @return void
		 */
		_bindHandlers() {
			if (Boolean(this.$element.data('center'))) {
				$window.on('resize', () => {
					this._handleCentering();
				});
			}
		}

		/**
		 * Handles the centering by adding or removing the css class
		 *
		 * @return void
		 */
		_handleCentering() {
			this.$element.toggleClass(ClassName.CAN_CENTER, this.length < this.slider.params.slidesPerView);
		}
	}

	return LocationsSlider._getElements($body.find(Selector.LOCATIONS_SLIDER), LocationsSlider);
})();

export default LocationsSlider;
